import { Controller } from "@hotwired/stimulus"
import { hideElement, showElement } from '@/helpers/animations_helpers';

export default class extends Controller {
  static targets = ["card", "title", "template", "addButton", "maxAlert", "deleteButton", "destroyInput"]

  connect() {
    this.updateTitles()
    this.toggleDeleteButtons()
  }

  addRule(event) {
    event.preventDefault()

    const newIndex = this.cardTargets.length

    // Check if we need to limit the number of rules
    if (newIndex >= 10) { // You can adjust this limit as needed
      this.addButtonTarget.classList.add("hidden")
      this.maxAlertTarget.classList.remove("hidden")
      return
    }

    const content = this.templateTarget.innerHTML
                      .replace(/NEW_RECORD/g, new Date().getTime())

    this.addButtonTarget.insertAdjacentHTML('beforebegin', content)
    this.updateTitles()
    this.toggleDeleteButtons()
  }

  markForDestroy(event) {
    // Get the card that contains the clicked delete button
    const card = event.target.closest('[data-tier-rules-target="card"]')

    // Find the index of this card in our cardTargets array
    const cardIndex = this.cardTargets.indexOf(card)

    // Use the index to get the corresponding destroyInput target
    const destroyInput = this.destroyInputTargets[cardIndex]

    destroyInput.value = true
    card.classList.add("hidden")

    this.updateTitles()
    this.toggleDeleteButtons()

    // Re-enable the add button if it was disabled
    this.addButtonTarget.classList.remove("hidden")
    this.maxAlertTarget.classList.add("hidden")
  }

  updateTitles() {
    let visibleIndex = 1

    // Iterate through cards and titles together
    this.cardTargets.forEach((card, index) => {
      if (!card.classList.contains("hidden")) {
        const titleElement = this.titleTargets[index]
        if (titleElement) {
          titleElement.textContent = `Rule #${visibleIndex}`
          visibleIndex++
        }
      }
    })
  }

  toggleDeleteButtons() {
    const visibleCards = this.cardTargets.filter(card => !card.classList.contains("hidden"))

    if (visibleCards.length <= 1) {
      this.deleteButtonTargets.forEach(button => button.classList.add("hidden"))
    } else {
      this.deleteButtonTargets.forEach(button => button.classList.remove("hidden"))
    }
  }
}
